module.exports = __webpack_public_path__ + "static/media/bat.39d03b9a.mp3";